import React from 'react';
import { AnnouncementBar } from './components/AnnouncementBar';
import { Hero } from './components/Hero';
import { Problems } from './components/Problems';
import { Solution } from './components/Solution';
import { HowItWorks } from './components/HowItWorks';
import { ProjectsCarousel } from './components/ProjectsCarousel';
import { Materials } from './components/Materials';
import { Bonuses } from './components/Bonuses';
import { MockupReminder } from './components/MockupReminder';
import { Offer } from './components/Offer';
import { Testimonials } from './components/Testimonials';
import { Faq } from './components/Faq';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
import { MetaPixel } from './components/MetaPixel';
export function App() {
  return <div className="min-h-full w-full bg-cream font-sans text-ink" data-id="element-0" data-mp="28tw9l3rof699">
      <MetaPixel data-id="element-1" data-mp="28s30zixi6bym" />
      <AnnouncementBar data-id="element-2" data-mp="23vkzqt1dsvr1" />
      <main data-id="element-3" data-mp="23u9uspw79hyc">
        <Hero data-id="element-4" data-mp="23ujha3i1d6za" />
        <Problems data-id="element-5" data-mp="23v2tr4ox335x" />
        <Solution data-id="element-6" data-mp="23ti67z10skhk" />
        <HowItWorks data-id="element-7" data-mp="3ik7k0rkruvvx" />
        <MockupReminder data-id="element-8" data-mp="3iiwdwl3utc1n" />
        <ProjectsCarousel data-id="element-9" data-mp="3ijfthv617oci" />
        <Materials data-id="element-10" data-mp="3ii4qhxkeukmg" />
        <Bonuses data-id="element-11" data-mp="3mlatmwc87vop" />
        <Offer data-id="element-12" data-mp="3mkrgru1fnxhj" />
        <Testimonials data-id="element-13" data-mp="3mk84otygs3bf" />
        <Faq data-id="element-14" data-mp="3mjgannkimdn9" />
        <FinalCta data-id="element-15" data-mp="3mj6lg27aoaim" />
      </main>
      <Footer data-id="element-16" data-mp="3rbzmog3k10py" />
    </div>;
}